import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { PinsContentSection } from './PinsPage';

interface Project { id: string; name: string; domain: string; brandId: string | null; enabled: boolean; nextSince: string | null }

export function PinsContentPage() {
  const [projects, setProjects] = useState<Project[]>([]);
  const [lastRun, setLastRun] = useState<string | null>(null);
  const [runMsg, setRunMsg] = useState<string | null>(null);
  const [running, setRunning] = useState(false);
  const loadStatus = () => fetch('/api/autopilot/pins/status').then((r) => r.json()).then((d) => setLastRun(d.lastRun ?? null)).catch(() => undefined);
  useEffect(() => { api.pinsPanel.projects().then(setProjects).catch(() => undefined); loadStatus(); }, []);
  const runNow = async () => {
    setRunning(true); setRunMsg(null);
    try {
      const r = await fetch('/api/autopilot/pins/run', { method: 'POST' });
      const d = await r.json();
      setRunMsg(`Domeny: ${d.domains} · wygenerowano: ${d.generated} · wysłano: ${d.pushed} · błędy: ${d.failed} · pominięte: ${d.skipped}`);
      loadStatus();
    } catch (e) { setRunMsg((e as Error).message); }
    finally { setRunning(false); }
  };
  return (
    <div>
      <h2>PINS Content</h2>
      <p className="muted">Artykuły per domena: generowanie (Artykuł / Narzędzia / Gry) + approve + push do PINS.</p>
      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card__header">Dzienny autopilot PINS</div>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <span className="muted" style={{ fontSize: 12.5 }}>Ostatnie uruchomienie: {lastRun ?? '—'}</span>
          <button className="btn btn--primary" onClick={runNow} disabled={running}>{running ? 'Uruchamiam…' : 'Uruchom teraz (2 art./domena)'}</button>
        </div>
        {runMsg && <div className="alert" style={{ marginTop: 8 }}>{runMsg}</div>}
      </div>
      <PinsContentSection projects={projects} />
    </div>
  );
}
